import usePartnerAuthStore from '@/stores/partnerAuthStore';
import type { NavigationGuardWithThis } from 'vue-router';

export default <NavigationGuardWithThis<undefined>>(async (to, _from, next) => {
  const partnerAuthStore = usePartnerAuthStore();

  if (!partnerAuthStore.meChecked) {
    await partnerAuthStore.getMe();
  }

  if (!partnerAuthStore.isAuth && to.name !== 'partner.login') {
    return next({ name: 'partner.login' });
  }

  return next();
});
